
// New Google Maps-based implementation

import React, { useEffect, useState, useRef } from "react";
import tripEnd from "../../constants/tripend.png";
import axios from "axios";
import { API_BASE_PATH } from "../../constants/workerConstants";
import { connect } from "react-redux";
import {
  GoogleMap,
  Marker,
  Polyline,
  InfoWindow,
  useLoadScript,
} from "@react-google-maps/api";
import { FadeLoader } from "react-spinners";
const mapContainerStyle = {
  height: "500px",
  width: "100%",
  borderRadius: "12px",
  boxShadow: "0 2px 8px rgba(0,0,0,0.2)",
};

function Mapcomponent(props) {
    const [coords, setCoords] = useState([]); 
     const [newCords ,setNewCords]=useState([]); 
   const [center, setCenter] = useState(null);
   const [isLoading, setIsLoading] = useState(false);
  const [selectedMarker, setSelectedMarker] = useState(null); // For InfoWindow
  const mapRef = useRef(null);

  const startsAfterISO = new Date(props.start.timestamp).toISOString();
  const endsBeforeISO = new Date(props.end.timestamp).toISOString();

  const { isLoaded } = useLoadScript({
    googleMapsApiKey: "AIzaSyCuxBwkNigQFhPxy-jOVESwDayIOuF-01c",
  });

  const getTripData = async () => {
    try {
      setIsLoading(true);
      const res = await axios.get(
        `${API_BASE_PATH}/bouncie/getTripData?ends-before=${endsBeforeISO}&gps-format=geojson&imei=${props.imei}&starts-after=${startsAfterISO}&transaction-id=${props.transactionId}`,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: props.authToken,
          },
        }
      );

      if (res.data?.length > 0) {
        const points = res.data[0].gps.coordinates.map(([lng, lat]) => ({
          lat,
          lng,
        }));
        setCoords(points);
     
        props.setdata(res.data);
    

      }
    } catch (err) {
      console.error("Error fetching trip data:", err);
    }finally{
      setIsLoading(false);
    }
  };

  useEffect(() => {
    getTripData();
  }, []);


  const start = coords[0];
  const end = coords[coords.length - 1];
 
  //  Fit both start and end markers within view
  useEffect(() => {
    if (mapRef.current && newCords.length > 1 && window.google) {
      const bounds = new window.google.maps.LatLngBounds();
      newCords.forEach((c) => bounds.extend(c));
      mapRef.current.fitBounds(bounds,{top: 30, right: 30, bottom: 30, left: 30}); // '80' adds padding so both points are comfortably visible
    }
  }, [newCords]);

useEffect(() => {
  if (coords.length > 0) {
    console.log("Calculating center for coords:", coords);
    const lats = coords.map((c) => c.lat);
    const lngs = coords.map((c) => c.lng);
    const maxlat = Math.max(...lats);
    const minlat = Math.min(...lats);
    const maxlong = Math.max(...lngs);
    const minlong = Math.min(...lngs);

    const centerLat = (maxlat + minlat) / 2;
    const centerLng = (maxlong + minlong) / 2;
           setNewCords([
             { lat: maxlat, lng: maxlong },
              { lat: minlat, lng: minlong }
              ]);
  
    setCenter({ lat: centerLat, lng: centerLng });
  }
}, [coords]);

  if (!isLoaded) return <p className="text-center">Loading Google Maps...</p>;

if (coords.length === 0)
  return (
    <div
      className="text-center"
      style={{
        backgroundColor: isLoading
          ? "rgb(29 117 189 / 85%)"
          : "rgb(29, 117, 189)",
        color: "rgba(37, 3, 3, 1)",
        borderRadius: "5px",
        width: "40%",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        height: "40px",
        padding: "0 10px",
        margin: "0 auto",
      }}
    >
      <span style={{ marginRight: "8px", fontSize: "14px" }}>Loading map...</span>
      
      {/* Small circle loader */}
      <div
        style={{
          border: "2px solid #fff",
          borderTop: "2px solid rgba(255,255,255,0.3)",
          borderRadius: "50%",
          width: "14px",       // match text height
          height: "14px",      // match text height
          animation: "spin 1s linear infinite",
        }}
      />
      
      {/* Spinner animation */}
      <style>
        {`
          @keyframes spin {
            0% { transform: rotate(0deg); }
            100% { transform: rotate(360deg); }
          }
        `}
      </style>
    </div>
  );




  return (
    <GoogleMap
      mapContainerStyle={mapContainerStyle}
      onLoad={(map) => (mapRef.current = map)}
      center={center}
      zoom={11}
      options={{
        streetViewControl: false,
        mapTypeControl: true,
        fullscreenControl: true,
      }}
    >
      {/*  Trip Path */}
      <Polyline
        path={coords}
        options={{
          strokeColor: "#007bff",
          strokeOpacity: 1.0,
          strokeWeight: 4,
        }}
      />

      {/*  Start Marker */}
      <Marker
        position={start}
        icon={{
          url: "https://cdn-icons-png.flaticon.com/128/668/668087.png",
          scaledSize: new window.google.maps.Size(30, 30),
          anchor: new window.google.maps.Point(15, 30),
        }}
        onClick={() => setSelectedMarker({ type: "start", position: start })}
      />

      {/*  End Marker */}
      <Marker
        position={end}
        icon={{
          url: tripEnd,
          scaledSize: new window.google.maps.Size(60, 45),
          anchor: new window.google.maps.Point(30, 45),
        }}
        onClick={() => setSelectedMarker({ type: "end", position: end })}
      />

      {/*  InfoWindow (shows on click) */}
      {selectedMarker && (
        <InfoWindow
          position={selectedMarker.position}
          onCloseClick={() => setSelectedMarker(null)}
        >
          <div style={{ fontWeight: "bold" }}>
            {selectedMarker.type === "start" ? "Trip Start" : "Trip End"}
          </div>
        </InfoWindow>
      )}
    </GoogleMap>
  );
}

const mapStateToProps = (state) => ({
  authToken: state.persist.authToken,
});

export default connect(mapStateToProps)(Mapcomponent);





// import React, { useEffect, useState, useRef } from "react";
// import tripEnd from "../../constants/tripend.png";
// import axios from "axios";
// import { API_BASE_PATH } from "../../constants/workerConstants";
// import { connect } from "react-redux";
// import {
//   APIProvider,
//   Map,
//   AdvancedMarker,
//   InfoWindow,
//   useMap,
// } from "@vis.gl/react-google-maps";

// const mapContainerStyle = {
//   height: "500px",
//   width: "100%",
//   borderRadius: "12px",
//   boxShadow: "0 2px 8px rgba(0,0,0,0.2)",
// };

// // Polyline component for vis.gl
// const PolylineComponent = ({ path }) => {
//   const map = useMap();

//   useEffect(() => {
//     if (!map || !path || path.length === 0) return;

//     const polyline = new window.google.maps.Polyline({
//       path: path,
//       strokeColor: "#007bff",
//       strokeOpacity: 1.0,
//       strokeWeight: 4,
//       map: map,
//     });

//     return () => {
//       polyline.setMap(null);
//     };
//   }, [map, path]);

//   return null;
// };

// // Custom hook for zoom animation
// const useZoomAnimation = ({ center, newCords, hasAnimated, setHasAnimated }) => {
//   const map = useMap();

//   useEffect(() => {
//     if (map && center && !hasAnimated && window.google && newCords.length > 1) {
//       // Calculate the target zoom level based on bounds
//       const bounds = new window.google.maps.LatLngBounds();
//       newCords.forEach((c) => bounds.extend(c));
//       map.fitBounds(bounds, { top: 40, right: 40, bottom: 40, left: 40 });

//       let targetZoom = 22;
//       setTimeout(() => {
//         targetZoom = map.getZoom();
//       }, 500);

//       // Start from space view
//       map.setZoom(4);
//       map.setCenter(center);

//       // Smooth continuous zoom animation
//       setTimeout(() => {
//         let currentZoom = 4;
//         const zoomIncrement = 0.2;
//         const frameDelay = 90;

//         const smoothZoom = () => {
//           if (currentZoom < targetZoom) {
//             currentZoom += zoomIncrement;
//             if (currentZoom > targetZoom) {
//               currentZoom = targetZoom;
//             }
//             map.setZoom(currentZoom);
//             setTimeout(smoothZoom, frameDelay);
//           } else {
//             // Animation complete, fit bounds precisely
//             setTimeout(() => {
//               map.fitBounds(bounds, { top: 40, right: 40, bottom: 40, left: 40 });
//               setHasAnimated(true);
//             }, 200);
//           }
//         };

//         smoothZoom();
//       }, 700);
//     }
//   }, [map, center, hasAnimated, newCords, setHasAnimated]);
// };

// // Inner map content component
// function MapContent({ coords, center, newCords, hasAnimated, setHasAnimated, selectedMarker, setSelectedMarker }) {
//   useZoomAnimation({ center, newCords, hasAnimated, setHasAnimated });

//   const start = coords[0];
//   const end = coords[coords.length - 1];

//   return (
//     <>
//       {/* Trip Path - Only show after animation */}
//       {hasAnimated && <PolylineComponent path={coords} />}

//       {/* Start Marker - Only show after animation */}
//       {hasAnimated && (
//         <AdvancedMarker
//           position={start}
//           onClick={() => setSelectedMarker({ type: "start", position: start })}
//         >
//           <img
//             src="https://cdn-icons-png.flaticon.com/128/668/668087.png"
//             width={30}
//             height={30}
//             alt="Start"
//             style={{ cursor: "pointer" }}
//           />
//         </AdvancedMarker>
//       )}

//       {/* End Marker - Only show after animation */}
//       {hasAnimated && (
//         <AdvancedMarker
//           position={end}
//           onClick={() => setSelectedMarker({ type: "end", position: end })}
//         >
//           <img
//             src={tripEnd}
//             width={60}
//             height={45}
//             alt="End"
//             style={{ cursor: "pointer" }}
//           />
//         </AdvancedMarker>
//       )}

//       {/* InfoWindow (shows on click) */}
//       {selectedMarker && (
//         <InfoWindow
//           position={selectedMarker.position}
//           onCloseClick={() => setSelectedMarker(null)}
//         >
//           <div style={{ fontWeight: "bold" }}>
//             {selectedMarker.type === "start" ? "Trip Start" : "Trip End"}
//           </div>
//         </InfoWindow>
//       )}
//     </>
//   );
// }

// function Mapcomponent(props) {
//   const [coords, setCoords] = useState([]);
//   const [newCords, setNewCords] = useState([]);
//   const [center, setCenter] = useState(null);
//   const [isLoading, setIsLoading] = useState(false);
//   const [selectedMarker, setSelectedMarker] = useState(null);
//   const [hasAnimated, setHasAnimated] = useState(false);

//   const startsAfterISO = new Date(props.start.timestamp).toISOString();
//   const endsBeforeISO = new Date(props.end.timestamp).toISOString();

//   const getTripData = async () => {
//     try {
//       setIsLoading(true);
//       const res = await axios.get(
//         `${API_BASE_PATH}/bouncie/getTripData?ends-before=${endsBeforeISO}&gps-format=geojson&imei=${props.imei}&starts-after=${startsAfterISO}&transaction-id=${props.transactionId}`,
//         {
//           headers: {
//             "Content-Type": "application/json",
//             Authorization: props.authToken,
//           },
//         }
//       );

//       if (res.data?.length > 0) {
//         const points = res.data[0].gps.coordinates.map(([lng, lat]) => ({
//           lat,
//           lng,
//         }));
//         setCoords(points);
//         props.setdata(res.data);
//       }
//     } catch (err) {
//       console.error("Error fetching trip data:", err);
//     } finally {
//       setIsLoading(false);
//     }
//   };

//   useEffect(() => {
//     getTripData();
//   }, []);

//   useEffect(() => {
//     if (coords.length > 0) {
//       const lats = coords.map((c) => c.lat);
//       const lngs = coords.map((c) => c.lng);
//       const maxlat = Math.max(...lats);
//       const minlat = Math.min(...lats);
//       const maxlong = Math.max(...lngs);
//       const minlong = Math.min(...lngs);

//       const centerLat = (maxlat + minlat) / 2;
//       const centerLng = (maxlong + minlong) / 2;
//       setNewCords([
//         { lat: maxlat, lng: maxlong },
//         { lat: minlat, lng: minlong },
//       ]);

//       setCenter({ lat: centerLat, lng: centerLng });
//     }
//   }, [coords]);

//   if (coords.length === 0)
//     return (
//       <div
//         className="text-center"
//         style={{
//           backgroundColor: isLoading
//             ? "rgb(29 117 189 / 85%)"
//             : "rgb(29, 117, 189)",
//           color: "rgba(37, 3, 3, 1)",
//           borderRadius: "5px",
//           width: "40%",
//           display: "flex",
//           justifyContent: "center",
//           alignItems: "center",
//           height: "40px",
//           padding: "0 10px",
//           margin: "0 auto",
//         }}
//       >
//         <span style={{ marginRight: "8px", fontSize: "14px" }}>
//           Loading map...
//         </span>

//         {/* Small circle loader */}
//         <div
//           style={{
//             border: "2px solid #fff",
//             borderTop: "2px solid rgba(255,255,255,0.3)",
//             borderRadius: "50%",
//             width: "14px",
//             height: "14px",
//             animation: "spin 1s linear infinite",
//           }}
//         />

//         {/* Spinner animation */}
//         <style>
//           {`
//           @keyframes spin {
//             0% { transform: rotate(0deg); }
//             100% { transform: rotate(360deg); }
//           }
//         `}
//         </style>
//       </div>
//     );

//   return (
//     <APIProvider apiKey="AIzaSyCuxBwkNigQFhPxy-jOVESwDayIOuF-01c">
//       <div style={mapContainerStyle}>
//         <Map
//           defaultCenter={center}
//           defaultZoom={1}
//           mapId="DEMO_MAP_ID" // Required for AdvancedMarker
//           gestureHandling="greedy"
//           disableDefaultUI={false}
//           streetViewControl={false}
//           mapTypeControl={true}
//           fullscreenControl={true}
//         >
//           <MapContent
//             coords={coords}
//             center={center}
//             newCords={newCords}
//             hasAnimated={hasAnimated}
//             setHasAnimated={setHasAnimated}
//             selectedMarker={selectedMarker}
//             setSelectedMarker={setSelectedMarker}
//           />
//         </Map>
//       </div>
//     </APIProvider>
//   );
// }

// const mapStateToProps = (state) => ({
//   authToken: state.persist.authToken,
// });

// export default connect(mapStateToProps)(Mapcomponent);


///working google react map/api code

// import React, { useEffect, useState, useRef } from "react";
// import tripEnd from "../../constants/tripend.png";
// import axios from "axios";
// import { API_BASE_PATH } from "../../constants/workerConstants";
// import { connect } from "react-redux";
// import {
//   GoogleMap,
//   Marker,
//   Polyline,
//   InfoWindow,
//   useLoadScript,
// } from "@react-google-maps/api";
// //import { FadeLoader } from "react-spinners";
// const mapContainerStyle = {
//   height: "500px",
//   width: "100%",
//   borderRadius: "12px",
//   boxShadow: "0 2px 8px rgba(0,0,0,0.2)",
// };

// function Mapcomponent(props) {
//     const [coords, setCoords] = useState([]); 
//      const [newCords ,setNewCords]=useState([]); 
//    const [center, setCenter] = useState(null);
//    const [isLoading, setIsLoading] = useState(false);
//   const [selectedMarker, setSelectedMarker] = useState(null); // For InfoWindow
//   const [hasAnimated, setHasAnimated] = useState(false); // Track if animation is done
//   const mapRef = useRef(null);

//   const startsAfterISO = new Date(props.start.timestamp).toISOString();
//   const endsBeforeISO = new Date(props.end.timestamp).toISOString();

//   const { isLoaded } = useLoadScript({
//     googleMapsApiKey: "AIzaSyCuxBwkNigQFhPxy-jOVESwDayIOuF-01c",
//   });

//   const getTripData = async () => {
//     try {
//       setIsLoading(true);
//       const res = await axios.get(
//         `${API_BASE_PATH}/bouncie/getTripData?ends-before=${endsBeforeISO}&gps-format=geojson&imei=${props.imei}&starts-after=${startsAfterISO}&transaction-id=${props.transactionId}`,
//         {
//           headers: {
//             "Content-Type": "application/json",
//             Authorization: props.authToken,
//           },
//         }
//       );

//       if (res.data?.length > 0) {
//         const points = res.data[0].gps.coordinates.map(([lng, lat]) => ({
//           lat,
//           lng,
//         }));
//         setCoords(points);
     
//         props.setdata(res.data);
    

//       }
//     } catch (err) {
//       console.error("Error fetching trip data:", err);
//     }finally{
//       setIsLoading(false);
//     }
//   };

//   useEffect(() => {
//     getTripData();
//   }, []);


//   const start = coords[0];
//   const end = coords[coords.length - 1];
 
//   // Zoom animation from space
 

//    //Fit both start and end markers within view
//   // useEffect(() => {
//   //   if (mapRef.current && newCords.length > 1 && window.google && hasAnimated) {
//   //     const bounds = new window.google.maps.LatLngBounds();
//   //     newCords.forEach((c) => bounds.extend(c));
//   //     mapRef.current.fitBounds(bounds,{top: 40, right: 40, bottom: 40, left: 40}); //  adds padding so both points are comfortably visible
//   //   }
//   // }, [newCords, hasAnimated]);

//  useEffect(() => {
//     if (mapRef.current && center && !hasAnimated && window.google && newCords.length > 1) {
//       const map = mapRef.current;
      
//       // Calculate the target zoom level based on bounds
//       const bounds = new window.google.maps.LatLngBounds();
//       newCords.forEach((c) => bounds.extend(c));
//       map.fitBounds(bounds,{top: 40, right: 40, bottom: 40, left: 40});
//       // Get the zoom level that fits the bounds
//       // const tempMap = new window.google.maps.Map(document.createElement('div'));
//       // tempMap.fitBounds(bounds);
//       let targetZoom = 15; 
//       setTimeout(() => {
//         targetZoom = map.getZoom();
//       }, 500);
//       // Start from space view
//       map.setZoom(4);
//       map.setCenter(center);
      
//       // Smooth continuous zoom animation
//       setTimeout(() => {
//         let currentZoom = 4;
//         const zoomIncrement = 0.2; // Smaller increment for smoother animation
//         const frameDelay = 90; // Faster frame rate for smooth animation
        
//         const smoothZoom = () => {
         
//           if (currentZoom < targetZoom) {
//             currentZoom += zoomIncrement;
//             if (currentZoom > targetZoom) {
//               currentZoom = targetZoom;
//             }
//             map.setZoom(currentZoom);
//             setTimeout(smoothZoom, frameDelay);
//           } else {
//             // Animation complete, fit bounds precisely
//             setTimeout(() => {
//               map.fitBounds(bounds, {top: 40, right: 40, bottom: 40, left: 40});
//               setHasAnimated(true);
//             }, 200);
//           }
//         };
        
//         smoothZoom();
//       }, 700);
//     }
//   }, [center, hasAnimated, newCords]);



// useEffect(() => {
//   if (coords.length > 0) {
//     //console.log("Calculating center for coords:", coords);
//     const lats = coords.map((c) => c.lat);
//     const lngs = coords.map((c) => c.lng);
//     const maxlat = Math.max(...lats);
//     const minlat = Math.min(...lats);
//     const maxlong = Math.max(...lngs);
//     const minlong = Math.min(...lngs);

//     const centerLat = (maxlat + minlat) / 2;
//     const centerLng = (maxlong + minlong) / 2;
//            setNewCords([
//              { lat: maxlat, lng: maxlong },
//               { lat: minlat, lng: minlong }
//               ]);
  
//     setCenter({ lat: centerLat, lng: centerLng });
//   }
// }, [coords]);

//   if (!isLoaded) return <p className="text-center">Loading Google Maps...</p>;

// if (coords.length === 0)
//   return (
//     <div
//       className="text-center"
//       style={{
//         backgroundColor: isLoading
//           ? "rgb(29 117 189 / 85%)"
//           : "rgb(29, 117, 189)",
//         color: "rgba(37, 3, 3, 1)",
//         borderRadius: "5px",
//         width: "40%",
//         display: "flex",
//         justifyContent: "center",
//         alignItems: "center",
//         height: "40px",
//         padding: "0 10px",
//         margin: "0 auto",
//       }}
//     >
//       <span style={{ marginRight: "8px", fontSize: "14px" }}>Loading map...</span>
      
//       {/* Small circle loader */}
//       <div
//         style={{
//           border: "2px solid #fff",
//           borderTop: "2px solid rgba(255,255,255,0.3)",
//           borderRadius: "50%",
//           width: "14px",       // match text height
//           height: "14px",      // match text height
//           animation: "spin 1s linear infinite",
//         }}
//       />
      
//       {/* Spinner animation */}
//       <style>
//         {`
//           @keyframes spin {
//             0% { transform: rotate(0deg); }
//             100% { transform: rotate(360deg); }
//           }
//         `}
//       </style>
//     </div>
//   );




//   return (
//     <GoogleMap
//       mapContainerStyle={mapContainerStyle}
//       onLoad={(map) => (mapRef.current = map)}
//       center={center}
//       zoom={1}
//       options={{
//         streetViewControl: false,
//         mapTypeControl: true,
//         fullscreenControl: true,
       
//       }}
//     >
//       {/*  Trip Path - Only show after animation */}
//       {hasAnimated && (
//         <Polyline
//           path={coords}
//           options={{
//             strokeColor: "#007bff",
//             strokeOpacity: 1.0,
//             strokeWeight: 4,
//           }}
//         />
//       )}

//       {/*  Start Marker - Only show after animation */}
//       {hasAnimated && (
//         <Marker
//           position={start}
//           icon={{
//             url: "https://cdn-icons-png.flaticon.com/128/668/668087.png",
//             scaledSize: new window.google.maps.Size(30, 30),
//             anchor: new window.google.maps.Point(15, 30),
//           }}
//           onClick={() => setSelectedMarker({ type: "start", position: start })}
//         />
//       )}

//       {/*  End Marker - Only show after animation */}
//       {hasAnimated && (
//         <Marker
//           position={end}
//           icon={{
//             url: tripEnd,
//             scaledSize: new window.google.maps.Size(60, 45),
//             anchor: new window.google.maps.Point(30, 45),
//           }}
//           onClick={() => setSelectedMarker({ type: "end", position: end })}
//         />
//       )}

//       {/*  InfoWindow (shows on click) */}
//       {selectedMarker && (
//         <InfoWindow
//           position={selectedMarker.position}
//           onCloseClick={() => setSelectedMarker(null)}
//         >
//           <div style={{ fontWeight: "bold" }}>
//             {selectedMarker.type === "start" ? "Trip Start" : "Trip End"}
//           </div>
//         </InfoWindow>
//       )}
//     </GoogleMap>
//   );
// }

// const mapStateToProps = (state) => ({
//   authToken: state.persist.authToken,
// });

// export default connect(mapStateToProps)(Mapcomponent);













// Previous Leaflet-based implementation (for reference)

// import React, { useEffect, useState } from "react";
// import tripEnd from "../../constants/tripend.png";
// import {
//   MapContainer,
//   TileLayer,
//   Polyline,
//   Marker,
//   Popup,
//   useMap,
// } from "react-leaflet";
// import "leaflet/dist/leaflet.css";
// import axios from "axios";
// import { API_BASE_PATH } from "../../constants/workerConstants";
// import { connect } from "react-redux";
// import L from "leaflet";
// import { GoToBack } from "../../components/ui/GoToBack header/GoToBack";


// import markerShadow from "leaflet/dist/images/marker-shadow.png";

// // Custom start (green) and end (red) icons
// const startIcon = new L.Icon({
//  // iconUrl: "https://raw.githubusercontent.com/pointhi/leaflet-color-markers/master/img/marker-icon-2x-green.png",
//   iconUrl: "https://cdn-icons-png.flaticon.com/128/668/668087.png",
//   shadowUrl: markerShadow,
//   iconSize: [25, 41],
//   iconAnchor: [12, 41],
//   popupAnchor: [1, -34],
// });

// const endIcon = new L.Icon({
//   iconUrl: tripEnd,
//   shadowUrl: markerShadow,
//   iconSize: [62, 46],  // wider (was 25)
//   iconAnchor: [35, 41], // center adjusted (was 12)
//   popupAnchor: [5, -34],
// });
 

// //  Helper component to auto-fit the map to trip bounds
// function FitMapBounds({ coords }) {
//   const map = useMap();
//   useEffect(() => {
//     if (coords.length > 0) {
//       const bounds = L.latLngBounds(coords);
//       map.fitBounds(bounds, { padding: [40, 40] });
//     }
//   }, [coords, map]);
//   return null;
// }

// function Mapcomponent(props) {
//   const [coords, setCoords] = useState([]);

//   // ✅ Convert dates to ISO format
//   const startsAfterISO = new Date(props.start.timestamp).toISOString();
//   const endsBeforeISO = new Date(props.end.timestamp).toISOString();

//   const getTripData = async () => {
//     try {
//       const res = await axios.get(
//         `${API_BASE_PATH}/bouncie/getTripData?ends-before=${endsBeforeISO}&gps-format=geojson&imei=${props.imei}&starts-after=${startsAfterISO}&transaction-id=${props.transactionId}`,
//         {
//           headers: {
//             "Content-Type": "application/json",
//             Authorization: props.authToken,
//           },
//         }
//       );

//       if (res.data?.length > 0) {
//         // GeoJSON stores [lng, lat], convert to [lat, lng]
//         const points = res.data[0].gps.coordinates.map(([lng, lat]) => [
//           lat,
//           lng,
//         ]);
//         setCoords(points);
//         props.setdata(res.data)
//       }
//     } catch (err) {
//       console.error("Error fetching trip data:", err);
//     }
//   };

//   useEffect(() => {
//     getTripData();
//   }, []);

//   if (coords.length === 0) return <p className="text-center">Loading map...</p>;

//   const start = coords[0];
//   const end = coords[coords.length - 1];

//   return (
//     <>
//     <MapContainer
//       center={start}
//       zoom={14}
//       style={{
//         height: "500px",
//         width: "100%",
//        // margin: "20px auto",
//         borderRadius: "12px",
//         boxShadow: "0 2px 8px rgba(0,0,0,0.2)",
//       }}
//     >
//       {/* Base map */}
//       <TileLayer
//         url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
//         attribution="© OpenStreetMap contributors"
//       />

//       {/* Polyline for the trip path */}
//       <Polyline positions={coords} color="blue" weight={4} />

//       {/* Start marker */}
//       <Marker position={start} icon={startIcon}>
//         <Popup>Trip Start</Popup>
//       </Marker>

//       {/* End marker */}
//       <Marker position={end} icon={endIcon}>
//         <Popup>Trip End</Popup>
//       </Marker>

//       {/* Auto-fit map to route */}
//       <FitMapBounds coords={coords} />
//     </MapContainer>

//     </>
//   );
// }

// const mapStateToProps = (state) => ({
//   authToken: state.persist.authToken,
// });

// export default connect(mapStateToProps)(Mapcomponent);
